import { render } from "./FooterPart.vue?vue&type=template&id=3a39d245"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import "./FooterPart.vue?vue&type=style&index=0&id=3a39d245&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__